/*! @wharfkit/hyperion v4.0.0-rc5 | BSD-3-Clause | Copyright (c) 2023 Greymass Inc. | https://github.com/wharfkit/js */
import { ABI, API, BlockTimestamp, Checksum256, Float64, Int64, Name, PermissionLevel, Struct, TimePoint, UInt32, UInt64, UInt8 } from "@wharfkit/antelope";
//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
//#endregion
//#region src/endpoints/v1/v1.ts
var HyperionV1APIClient = class {
	constructor(client) {
		this.client = client;
		this.history = new HyperionV1HistoryAPIClient(client);
		this.chain = new HyperionV1ChainAPIClient(client);
		this.trace_api = new HyperionV1TraceApiClient(client);
	}
};
var HyperionV1HistoryAPIClient = class {
	constructor(client) {
		this.client = client;
	}
	async get_actions() {
		throw new Error("Method not implemented.");
	}
	async get_controlled_accounts() {
		throw new Error("Method not implemented.");
	}
	async get_key_accounts() {
		throw new Error("Method not implemented.");
	}
	async get_transaction() {
		throw new Error("Method not implemented.");
	}
};
var HyperionV1ChainAPIClient = class {
	constructor(client) {
		this.client = client;
	}
	async get_block() {
		throw new Error("Method not implemented.");
	}
};
var HyperionV1TraceApiClient = class {
	constructor(client) {
		this.client = client;
	}
	async get_block() {
		throw new Error("Method not implemented.");
	}
};
//#endregion
//#region \0@oxc-project+runtime@0.147.0/helpers/esm/decorate.js
function __decorate(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
}
//#endregion
//#region src/endpoints/v2/types.ts
var types_exports$1 = __exportAll({
	AccountInfo: () => AccountInfo,
	AccountSequence: () => AccountSequence,
	Action: () => Action,
	ActionAct: () => ActionAct,
	ActionRamDelta: () => ActionRamDelta,
	ActionReceipt: () => ActionReceipt,
	Approval: () => Approval,
	Delta: () => Delta,
	ElasticsearchServiceData: () => ElasticsearchServiceData,
	Features: () => Features,
	GetABISnapshotResponse: () => GetABISnapshotResponse,
	GetAccountResponse: () => GetAccountResponse,
	GetAccountResponseLink: () => GetAccountResponseLink,
	GetActionsResponse: () => GetActionsResponse,
	GetCreatedAccountsResponse: () => GetCreatedAccountsResponse,
	GetCreatorResponse: () => GetCreatorResponse,
	GetDeltasResponse: () => GetDeltasResponse,
	GetHealthResponse: () => GetHealthResponse,
	GetKeyAccountsResponse: () => GetKeyAccountsResponse,
	GetLinksResponse: () => GetLinksResponse,
	GetLinksResponseLink: () => GetLinksResponseLink,
	GetProposalsResponse: () => GetProposalsResponse,
	GetTableStateResponse: () => GetTableStateResponse,
	GetTokensResponse: () => GetTokensResponse,
	GetTransactionResponse: () => GetTransactionResponse,
	GetVotersResponse: () => GetVotersResponse,
	GetVotersResponseVoter: () => GetVotersResponseVoter,
	HealthEntry: () => HealthEntry,
	NodeosRPCServiceData: () => NodeosRPCServiceData,
	Proposal: () => Proposal,
	StreamingFeatures: () => StreamingFeatures,
	TablesFeatures: () => TablesFeatures,
	TokenInfo: () => TokenInfo,
	TotalCount: () => TotalCount
});
let GetABISnapshotResponse = class GetABISnapshotResponse extends Struct {};
__decorate([Struct.field(UInt32)], GetABISnapshotResponse.prototype, "block_num", void 0);
__decorate([Struct.field(ABI)], GetABISnapshotResponse.prototype, "abi", void 0);
__decorate([Struct.field(Float64)], GetABISnapshotResponse.prototype, "query_time_ms", void 0);
GetABISnapshotResponse = __decorate([Struct.type("get_abi_snapshot_response")], GetABISnapshotResponse);
let GetVotersResponseVoter = class GetVotersResponseVoter extends Struct {};
__decorate([Struct.field(Name)], GetVotersResponseVoter.prototype, "account", void 0);
__decorate([Struct.field(Float64)], GetVotersResponseVoter.prototype, "weight", void 0);
__decorate([Struct.field(UInt32)], GetVotersResponseVoter.prototype, "last_vote", void 0);
GetVotersResponseVoter = __decorate([Struct.type("get_voters_response_voter")], GetVotersResponseVoter);
let GetVotersResponse = class GetVotersResponse extends Struct {};
__decorate([Struct.field(GetVotersResponseVoter, { array: true })], GetVotersResponse.prototype, "voters", void 0);
GetVotersResponse = __decorate([Struct.type("get_voters_response")], GetVotersResponse);
let GetLinksResponseLink = class GetLinksResponseLink extends Struct {};
__decorate([Struct.field(UInt32)], GetLinksResponseLink.prototype, "block_num", void 0);
__decorate([Struct.field(BlockTimestamp)], GetLinksResponseLink.prototype, "timestamp", void 0);
__decorate([Struct.field(Name)], GetLinksResponseLink.prototype, "account", void 0);
__decorate([Struct.field("string")], GetLinksResponseLink.prototype, "permission", void 0);
__decorate([Struct.field("string")], GetLinksResponseLink.prototype, "code", void 0);
__decorate([Struct.field("string")], GetLinksResponseLink.prototype, "action", void 0);
__decorate([Struct.field("bool", { optional: true })], GetLinksResponseLink.prototype, "irreversible", void 0);
GetLinksResponseLink = __decorate([Struct.type("get_links_response_link")], GetLinksResponseLink);
let TotalCount = class TotalCount extends Struct {};
__decorate([Struct.field(UInt32)], TotalCount.prototype, "value", void 0);
__decorate([Struct.field("string")], TotalCount.prototype, "relation", void 0);
TotalCount = __decorate([Struct.type("total_count")], TotalCount);
let GetLinksResponse = class GetLinksResponse extends Struct {};
__decorate([Struct.field(Float64)], GetLinksResponse.prototype, "query_time_ms", void 0);
__decorate([Struct.field("bool")], GetLinksResponse.prototype, "cached", void 0);
__decorate([Struct.field("bool", { optional: true })], GetLinksResponse.prototype, "hot_only", void 0);
__decorate([Struct.field(UInt32, { optional: true })], GetLinksResponse.prototype, "lib", void 0);
__decorate([Struct.field(TotalCount)], GetLinksResponse.prototype, "total", void 0);
__decorate([Struct.field(GetLinksResponseLink, { array: true })], GetLinksResponse.prototype, "links", void 0);
GetLinksResponse = __decorate([Struct.type("get_links_response")], GetLinksResponse);
let Approval = class Approval extends Struct {};
__decorate([Struct.field(Name)], Approval.prototype, "actor", void 0);
__decorate([Struct.field(Name)], Approval.prototype, "permission", void 0);
__decorate([Struct.field(TimePoint)], Approval.prototype, "time", void 0);
Approval = __decorate([Struct.type("approval")], Approval);
let Proposal = class Proposal extends Struct {};
__decorate([Struct.field(Approval, { array: true })], Proposal.prototype, "provided_approvals", void 0);
__decorate([Struct.field(Approval, { array: true })], Proposal.prototype, "requested_approvals", void 0);
__decorate([Struct.field(UInt32)], Proposal.prototype, "block_num", void 0);
__decorate([Struct.field(Name)], Proposal.prototype, "proposer", void 0);
__decorate([Struct.field(Name)], Proposal.prototype, "proposal_name", void 0);
__decorate([Struct.field(UInt64)], Proposal.prototype, "primary_key", void 0);
__decorate([Struct.field("bool")], Proposal.prototype, "executed", void 0);
Proposal = __decorate([Struct.type("proposal")], Proposal);
let GetProposalsResponse = class GetProposalsResponse extends Struct {};
__decorate([Struct.field(Float64, { optional: true })], GetProposalsResponse.prototype, "query_time", void 0);
__decorate([Struct.field("bool")], GetProposalsResponse.prototype, "cached", void 0);
__decorate([Struct.field(TotalCount)], GetProposalsResponse.prototype, "total", void 0);
__decorate([Struct.field(Proposal, { array: true })], GetProposalsResponse.prototype, "proposals", void 0);
__decorate([Struct.field(Float64)], GetProposalsResponse.prototype, "query_time_ms", void 0);
GetProposalsResponse = __decorate([Struct.type("get_proposals_response")], GetProposalsResponse);
let ActionAct = class ActionAct extends Struct {};
__decorate([Struct.field(Name)], ActionAct.prototype, "account", void 0);
__decorate([Struct.field(Name)], ActionAct.prototype, "name", void 0);
__decorate([Struct.field(PermissionLevel, { array: true })], ActionAct.prototype, "authorization", void 0);
__decorate([Struct.field("any")], ActionAct.prototype, "data", void 0);
ActionAct = __decorate([Struct.type("act")], ActionAct);
let AccountSequence = class AccountSequence extends Struct {};
__decorate([Struct.field(Name)], AccountSequence.prototype, "account", void 0);
__decorate([Struct.field(UInt64)], AccountSequence.prototype, "sequence", void 0);
AccountSequence = __decorate([Struct.type("account_sequence")], AccountSequence);
let ActionReceipt = class ActionReceipt extends Struct {};
__decorate([Struct.field(Name)], ActionReceipt.prototype, "receiver", void 0);
__decorate([Struct.field(UInt64)], ActionReceipt.prototype, "global_sequence", void 0);
__decorate([Struct.field(UInt64)], ActionReceipt.prototype, "recv_sequence", void 0);
__decorate([Struct.field(AccountSequence, { array: true })], ActionReceipt.prototype, "auth_sequence", void 0);
ActionReceipt = __decorate([Struct.type("action_receipt")], ActionReceipt);
let ActionRamDelta = class ActionRamDelta extends Struct {};
__decorate([Struct.field(Name)], ActionRamDelta.prototype, "account", void 0);
__decorate([Struct.field(Int64)], ActionRamDelta.prototype, "delta", void 0);
ActionRamDelta = __decorate([Struct.type("action_ram_delta")], ActionRamDelta);
let Action = class Action extends Struct {};
__decorate([Struct.field(BlockTimestamp)], Action.prototype, "timestamp", void 0);
__decorate([Struct.field(UInt32)], Action.prototype, "block_num", void 0);
__decorate([Struct.field(Checksum256, { optional: true })], Action.prototype, "block_id", void 0);
__decorate([Struct.field(Checksum256)], Action.prototype, "trx_id", void 0);
__decorate([Struct.field(ActionAct)], Action.prototype, "act", void 0);
__decorate([Struct.field(ActionReceipt, {
	array: true,
	optional: true
})], Action.prototype, "receipts", void 0);
__decorate([Struct.field(ActionRamDelta, {
	array: true,
	optional: true
})], Action.prototype, "account_ram_deltas", void 0);
__decorate([Struct.field(UInt64)], Action.prototype, "global_sequence", void 0);
__decorate([Struct.field(Name)], Action.prototype, "producer", void 0);
__decorate([Struct.field(UInt64)], Action.prototype, "action_ordinal", void 0);
__decorate([Struct.field(UInt64)], Action.prototype, "creator_action_ordinal", void 0);
__decorate([Struct.field(UInt64, { optional: true })], Action.prototype, "cpu_usage_us", void 0);
__decorate([Struct.field(UInt64, { optional: true })], Action.prototype, "net_usage_words", void 0);
__decorate([Struct.field(UInt64, { optional: true })], Action.prototype, "parent", void 0);
__decorate([Struct.field("string", {
	array: true,
	optional: true
})], Action.prototype, "signatures", void 0);
Action = __decorate([Struct.type("action")], Action);
let GetActionsResponse = class GetActionsResponse extends Struct {};
__decorate([Struct.field(Float64)], GetActionsResponse.prototype, "query_time_ms", void 0);
__decorate([Struct.field("bool")], GetActionsResponse.prototype, "cached", void 0);
__decorate([Struct.field(UInt32, { optional: true })], GetActionsResponse.prototype, "lib", void 0);
__decorate([Struct.field(TotalCount)], GetActionsResponse.prototype, "total", void 0);
__decorate([Struct.field(Action, { array: true })], GetActionsResponse.prototype, "actions", void 0);
GetActionsResponse = __decorate([Struct.type("get_actions_response")], GetActionsResponse);
let AccountInfo = class AccountInfo extends Struct {};
__decorate([Struct.field(Name)], AccountInfo.prototype, "name", void 0);
__decorate([Struct.field(Checksum256)], AccountInfo.prototype, "trx_id", void 0);
__decorate([Struct.field(TimePoint)], AccountInfo.prototype, "timestamp", void 0);
AccountInfo = __decorate([Struct.type("account_info")], AccountInfo);
let GetCreatedAccountsResponse = class GetCreatedAccountsResponse extends Struct {};
__decorate([Struct.field(Float64)], GetCreatedAccountsResponse.prototype, "query_time_ms", void 0);
__decorate([Struct.field(AccountInfo, { array: true })], GetCreatedAccountsResponse.prototype, "accounts", void 0);
GetCreatedAccountsResponse = __decorate([Struct.type("get_created_accounts_response")], GetCreatedAccountsResponse);
let GetCreatorResponse = class GetCreatorResponse extends Struct {};
__decorate([Struct.field(Float64)], GetCreatorResponse.prototype, "query_time_ms", void 0);
__decorate([Struct.field(Name)], GetCreatorResponse.prototype, "account", void 0);
__decorate([Struct.field(Name)], GetCreatorResponse.prototype, "creator", void 0);
__decorate([Struct.field(BlockTimestamp)], GetCreatorResponse.prototype, "timestamp", void 0);
__decorate([Struct.field(UInt32)], GetCreatorResponse.prototype, "block_num", void 0);
__decorate([Struct.field(Checksum256)], GetCreatorResponse.prototype, "trx_id", void 0);
GetCreatorResponse = __decorate([Struct.type("get_creator_response")], GetCreatorResponse);
let Delta = class Delta extends Struct {};
__decorate([Struct.field(BlockTimestamp)], Delta.prototype, "timestamp", void 0);
__decorate([Struct.field(UInt8)], Delta.prototype, "present", void 0);
__decorate([Struct.field(Name)], Delta.prototype, "code", void 0);
__decorate([Struct.field(Name)], Delta.prototype, "scope", void 0);
__decorate([Struct.field(Name)], Delta.prototype, "table", void 0);
__decorate([Struct.field(Name)], Delta.prototype, "primary_key", void 0);
__decorate([Struct.field(Name)], Delta.prototype, "payer", void 0);
__decorate([Struct.field(UInt64)], Delta.prototype, "block_num", void 0);
__decorate([Struct.field(Checksum256)], Delta.prototype, "block_id", void 0);
__decorate([Struct.field("any")], Delta.prototype, "data", void 0);
Delta = __decorate([Struct.type("delta")], Delta);
let GetDeltasResponse = class GetDeltasResponse extends Struct {};
__decorate([Struct.field(Float64)], GetDeltasResponse.prototype, "query_time_ms", void 0);
__decorate([Struct.field(TotalCount)], GetDeltasResponse.prototype, "total", void 0);
__decorate([Struct.field(Delta, { array: true })], GetDeltasResponse.prototype, "deltas", void 0);
GetDeltasResponse = __decorate([Struct.type("get_deltas_response")], GetDeltasResponse);
let GetTableStateResponse = class GetTableStateResponse extends Struct {};
__decorate([Struct.field(Float64)], GetTableStateResponse.prototype, "query_time_ms", void 0);
__decorate([Struct.field(Name)], GetTableStateResponse.prototype, "code", void 0);
__decorate([Struct.field(Name)], GetTableStateResponse.prototype, "table", void 0);
__decorate([Struct.field(UInt64)], GetTableStateResponse.prototype, "block_num", void 0);
__decorate([Struct.field("string")], GetTableStateResponse.prototype, "after_key", void 0);
__decorate([Struct.field("string")], GetTableStateResponse.prototype, "next_key", void 0);
__decorate([Struct.field("any", { array: true })], GetTableStateResponse.prototype, "results", void 0);
GetTableStateResponse = __decorate([Struct.type("get_table_state_response")], GetTableStateResponse);
let GetKeyAccountsResponse = class GetKeyAccountsResponse extends Struct {};
__decorate([Struct.field(Name, { array: true })], GetKeyAccountsResponse.prototype, "account_names", void 0);
GetKeyAccountsResponse = __decorate([Struct.type("get_key_accounts_response")], GetKeyAccountsResponse);
let TokenInfo = class TokenInfo extends Struct {};
__decorate([Struct.field("string")], TokenInfo.prototype, "symbol", void 0);
__decorate([Struct.field(Float64)], TokenInfo.prototype, "amount", void 0);
__decorate([Struct.field("string")], TokenInfo.prototype, "contract", void 0);
__decorate([Struct.field(UInt32, { optional: true })], TokenInfo.prototype, "precision", void 0);
__decorate([Struct.field("string", { optional: true })], TokenInfo.prototype, "error", void 0);
TokenInfo = __decorate([Struct.type("token_info")], TokenInfo);
let GetTokensResponse = class GetTokensResponse extends Struct {};
__decorate([Struct.field(Name)], GetTokensResponse.prototype, "account", void 0);
__decorate([Struct.field(Float64)], GetTokensResponse.prototype, "query_time_ms", void 0);
__decorate([Struct.field(TokenInfo, { array: true })], GetTokensResponse.prototype, "tokens", void 0);
GetTokensResponse = __decorate([Struct.type("get_tokens_response")], GetTokensResponse);
let GetTransactionResponse = class GetTransactionResponse extends Struct {};
__decorate([Struct.field(Float64)], GetTransactionResponse.prototype, "query_time_ms", void 0);
__decorate([Struct.field("bool")], GetTransactionResponse.prototype, "executed", void 0);
__decorate([Struct.field(Checksum256)], GetTransactionResponse.prototype, "trx_id", void 0);
__decorate([Struct.field(UInt32)], GetTransactionResponse.prototype, "lib", void 0);
__decorate([Struct.field("bool")], GetTransactionResponse.prototype, "cached_lib", void 0);
__decorate([Struct.field(Action, { array: true })], GetTransactionResponse.prototype, "actions", void 0);
GetTransactionResponse = __decorate([Struct.type("get_transaction_response")], GetTransactionResponse);
let GetAccountResponseLink = class GetAccountResponseLink extends Struct {};
__decorate([Struct.field(BlockTimestamp)], GetAccountResponseLink.prototype, "timestamp", void 0);
__decorate([Struct.field(Name)], GetAccountResponseLink.prototype, "permission", void 0);
__decorate([Struct.field(Name)], GetAccountResponseLink.prototype, "code", void 0);
__decorate([Struct.field(Name)], GetAccountResponseLink.prototype, "action", void 0);
GetAccountResponseLink = __decorate([Struct.type("get_account_response_link")], GetAccountResponseLink);
let GetAccountResponse = class GetAccountResponse extends Struct {};
__decorate([Struct.field(Float64)], GetAccountResponse.prototype, "query_time_ms", void 0);
__decorate([Struct.field(API.v1.AccountObject)], GetAccountResponse.prototype, "account", void 0);
__decorate([Struct.field(GetAccountResponseLink, { array: true })], GetAccountResponse.prototype, "links", void 0);
__decorate([Struct.field(TokenInfo, { array: true })], GetAccountResponse.prototype, "tokens", void 0);
__decorate([Struct.field(UInt64)], GetAccountResponse.prototype, "total_actions", void 0);
__decorate([Struct.field(Action, { array: true })], GetAccountResponse.prototype, "actions", void 0);
GetAccountResponse = __decorate([Struct.type("get_account_response")], GetAccountResponse);
let HealthEntry = class HealthEntry extends Struct {};
__decorate([Struct.field("string")], HealthEntry.prototype, "service", void 0);
__decorate([Struct.field("string")], HealthEntry.prototype, "status", void 0);
__decorate([Struct.field("any", { optional: true })], HealthEntry.prototype, "service_data", void 0);
__decorate([Struct.field(UInt64)], HealthEntry.prototype, "time", void 0);
HealthEntry = __decorate([Struct.type("health_entry")], HealthEntry);
let NodeosRPCServiceData = class NodeosRPCServiceData extends Struct {};
__decorate([Struct.field(UInt64)], NodeosRPCServiceData.prototype, "head_block_num", void 0);
__decorate([Struct.field("string")], NodeosRPCServiceData.prototype, "head_block_time", void 0);
__decorate([Struct.field(UInt64)], NodeosRPCServiceData.prototype, "time_offset", void 0);
__decorate([Struct.field(UInt64)], NodeosRPCServiceData.prototype, "last_irreversible_block", void 0);
__decorate([Struct.field("string")], NodeosRPCServiceData.prototype, "chain_id", void 0);
NodeosRPCServiceData = __decorate([Struct.type("nodeos_rpc_service_data")], NodeosRPCServiceData);
let ElasticsearchServiceData = class ElasticsearchServiceData extends Struct {};
__decorate([Struct.field("string")], ElasticsearchServiceData.prototype, "active_shards", void 0);
__decorate([Struct.field(UInt64)], ElasticsearchServiceData.prototype, "head_offset", void 0);
__decorate([Struct.field(UInt64)], ElasticsearchServiceData.prototype, "first_indexed_block", void 0);
__decorate([Struct.field(UInt64)], ElasticsearchServiceData.prototype, "last_indexed_block", void 0);
__decorate([Struct.field(UInt64)], ElasticsearchServiceData.prototype, "total_indexed_blocks", void 0);
__decorate([Struct.field(UInt64)], ElasticsearchServiceData.prototype, "missing_blocks", void 0);
__decorate([Struct.field("string")], ElasticsearchServiceData.prototype, "missing_pct", void 0);
ElasticsearchServiceData = __decorate([Struct.type("elasticsearch_service_data")], ElasticsearchServiceData);
let StreamingFeatures = class StreamingFeatures extends Struct {};
__decorate([Struct.field("bool")], StreamingFeatures.prototype, "enable", void 0);
__decorate([Struct.field("bool")], StreamingFeatures.prototype, "traces", void 0);
__decorate([Struct.field("bool")], StreamingFeatures.prototype, "deltas", void 0);
StreamingFeatures = __decorate([Struct.type("streaming_features")], StreamingFeatures);
let TablesFeatures = class TablesFeatures extends Struct {};
__decorate([Struct.field("bool")], TablesFeatures.prototype, "proposals", void 0);
__decorate([Struct.field("bool")], TablesFeatures.prototype, "accounts", void 0);
__decorate([Struct.field("bool")], TablesFeatures.prototype, "voters", void 0);
TablesFeatures = __decorate([Struct.type("tables_features")], TablesFeatures);
let Features = class Features extends Struct {};
__decorate([Struct.field(StreamingFeatures)], Features.prototype, "streaming", void 0);
__decorate([Struct.field(TablesFeatures)], Features.prototype, "tables", void 0);
__decorate([Struct.field("bool")], Features.prototype, "index_deltas", void 0);
__decorate([Struct.field("bool")], Features.prototype, "index_transfer_memo", void 0);
__decorate([Struct.field("bool")], Features.prototype, "index_all_deltas", void 0);
__decorate([Struct.field("bool")], Features.prototype, "deferred_trx", void 0);
__decorate([Struct.field("bool")], Features.prototype, "failed_trx", void 0);
__decorate([Struct.field("bool")], Features.prototype, "resource_limits", void 0);
__decorate([Struct.field("bool")], Features.prototype, "resource_usage", void 0);
Features = __decorate([Struct.type("features")], Features);
let GetHealthResponse = class GetHealthResponse extends Struct {};
__decorate([Struct.field("string")], GetHealthResponse.prototype, "version", void 0);
__decorate([Struct.field("string")], GetHealthResponse.prototype, "version_hash", void 0);
__decorate([Struct.field("string")], GetHealthResponse.prototype, "host", void 0);
__decorate([Struct.field(HealthEntry, { array: true })], GetHealthResponse.prototype, "health", void 0);
__decorate([Struct.field(Features)], GetHealthResponse.prototype, "features", void 0);
__decorate([Struct.field(Float64)], GetHealthResponse.prototype, "query_time_ms", void 0);
GetHealthResponse = __decorate([Struct.type("get_health_response")], GetHealthResponse);
//#endregion
//#region src/types.ts
var types_exports = __exportAll({ v2: () => types_exports$1 });
//#endregion
//#region src/endpoints/v2/v2.ts
var HyperionV2APIClient = class {
	constructor(client) {
		this.client = client;
		this.state = new HyperionV2StateAPIClient(client);
		this.history = new HyperionV2HistoryAPIClient(client);
	}
	get_health() {
		return this.client.call({
			path: `/v2/health`,
			method: "GET",
			responseType: GetHealthResponse
		});
	}
};
var HyperionV2StateAPIClient = class {
	constructor(client) {
		this.client = client;
	}
	async get_voters(producer, proxy, skip, limit) {
		const queryParts = [];
		if (producer) queryParts.push(`producer=${producer}`);
		if (proxy !== void 0) queryParts.push(`proxy=${proxy}`);
		if (skip !== void 0) queryParts.push(`skip=${skip}`);
		if (limit !== void 0) queryParts.push(`limit=${limit}`);
		const queryParams = queryParts.length ? "?" + queryParts.join("&") : "";
		return this.client.call({
			path: `/v2/state/get_voters${queryParams}`,
			method: "GET",
			responseType: GetVotersResponse
		});
	}
	async get_links(account, code, action, permission) {
		const queryParts = [];
		if (account !== void 0) queryParts.push(`account=${account}`);
		if (code !== void 0) queryParts.push(`code=${code}`);
		if (action !== void 0) queryParts.push(`action=${action}`);
		if (permission !== void 0) queryParts.push(`permission=${permission}`);
		const queryParams = queryParts.length ? "?" + queryParts.join("&") : "";
		return this.client.call({
			path: `/v2/state/get_links${queryParams}`,
			method: "GET",
			responseType: GetLinksResponse
		});
	}
	async get_key_accounts(public_key) {
		return this.client.call({
			path: `/v2/state/get_key_accounts?public_key=${public_key}`,
			method: "GET",
			responseType: GetKeyAccountsResponse
		});
	}
	async get_tokens(account) {
		return this.client.call({
			path: `/v2/state/get_tokens?account=${account}`,
			method: "GET",
			responseType: GetTokensResponse
		});
	}
	async get_proposals(options) {
		const queryParts = [];
		for (const [key, value] of Object.entries(options || {})) queryParts.push(`${key}=${value}`);
		const queryParams = queryParts.length ? "?" + queryParts.join("&") : "";
		return this.client.call({
			path: `/v2/state/get_proposals${queryParams}`,
			method: "GET",
			responseType: GetProposalsResponse
		});
	}
	async get_account(account) {
		return this.client.call({
			path: `/v2/state/get_account?account=${account}`,
			method: "GET",
			responseType: GetAccountResponse
		});
	}
};
var HyperionV2HistoryAPIClient = class {
	constructor(client) {
		this.client = client;
	}
	async get_abi_snapshot(contract, block, fetch = false) {
		if (!block) {
			const info = await this.client.v1.chain.get_info();
			block = Number(info.last_irreversible_block_num);
		}
		return this.client.call({
			path: `/v2/history/get_abi_snapshot?contract=${encodeURIComponent(contract)}&block=${block}&fetch=${fetch}`,
			method: "GET",
			responseType: GetABISnapshotResponse
		});
	}
	async get_actions(account, options) {
		const queryParts = [];
		if (account) queryParts.push(`account=${account}`);
		for (const [key, value] of Object.entries(options || {})) queryParts.push(`${key}=${value}`);
		const queryParams = queryParts.length ? "?" + queryParts.join("&") : "";
		return this.client.call({
			path: `/v2/history/get_actions${queryParams}`,
			method: "GET",
			responseType: GetActionsResponse
		});
	}
	async get_created_accounts(account, options) {
		const queryParts = [`account=${account}`];
		for (const [key, value] of Object.entries(options || {})) queryParts.push(`${key}=${value}`);
		const queryParams = queryParts.length ? "?" + queryParts.join("&") : "";
		return this.client.call({
			path: `/v2/history/get_created_accounts${queryParams}`,
			method: "GET",
			responseType: GetCreatedAccountsResponse
		});
	}
	async get_creator(account) {
		return this.client.call({
			path: `/v2/history/get_creator?account=${account}`,
			method: "GET",
			responseType: GetCreatorResponse
		});
	}
	async get_deltas(code, scope, table, payer) {
		return this.client.call({
			path: `/v2/history/get_deltas?code=${code}&scope=${scope}&table=${table}&payer=${payer}`,
			method: "GET",
			responseType: GetDeltasResponse
		});
	}
	async get_table_state(code, table, block_num, after_key = "") {
		return this.client.call({
			path: `/v2/history/get_table_state?code=${code}&table=${table}&block_num=${block_num}&after_key=${after_key}`,
			method: "GET",
			responseType: GetTableStateResponse
		});
	}
	async get_transaction(id) {
		return this.client.call({
			path: `/v2/history/get_transaction?id=${id}`,
			method: "GET",
			responseType: GetTransactionResponse
		});
	}
	async get_transfers() {
		throw new Error("Method not implemented.");
	}
	async get_transacted_accounts() {
		throw new Error("Method not implemented.");
	}
};
//#endregion
//#region src/endpoints.ts
var HyperionAPIClient = class {
	constructor(client) {
		this.client = client;
		this.v1 = new HyperionV1APIClient(client);
		this.v2 = new HyperionV2APIClient(client);
	}
};
//#endregion
export { HyperionAPIClient, types_exports as Types };

//# sourceMappingURL=hyperion.m.js.map